import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=logged out, obj=user

  useEffect(() => {
    const token = localStorage.getItem("leadify_token");
    if (!token) { setUser(null); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("leadify_token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.removeItem("leadify_super_token");
    localStorage.removeItem("leadify_impersonating");
    localStorage.setItem("leadify_token", data.token);
    localStorage.setItem("leadify_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("leadify_token", data.token);
    localStorage.setItem("leadify_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    if (user?.impersonated_by && localStorage.getItem("leadify_super_token")) { stopImpersonating(); return; }
    localStorage.removeItem("leadify_super_token");
    localStorage.removeItem("leadify_impersonating");
    localStorage.removeItem("leadify_token");
    localStorage.removeItem("leadify_user");
    setUser(null);
    window.location.href = "/login";
  };

  const impersonate = async (companyId) => {
    const { data } = await api.post(`/superadmin/companies/${companyId}/impersonate`);
    localStorage.setItem("leadify_super_token", localStorage.getItem("leadify_token"));
    localStorage.setItem("leadify_impersonating", data.company_name);
    localStorage.removeItem("leadify_selected_division");
    localStorage.setItem("leadify_token", data.token);
    localStorage.setItem("leadify_user", JSON.stringify(data.user));
    window.location.href = "/";
  };

  const stopImpersonating = async () => {
    try { await api.post("/superadmin/impersonation/end"); } catch { /* token may be expired */ }
    const superToken = localStorage.getItem("leadify_super_token");
    localStorage.removeItem("leadify_super_token");
    localStorage.removeItem("leadify_impersonating");
    localStorage.removeItem("leadify_selected_division");
    localStorage.removeItem("leadify_user");
    if (superToken) localStorage.setItem("leadify_token", superToken);
    else localStorage.removeItem("leadify_token");
    window.location.href = superToken ? "/admin" : "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, impersonate, stopImpersonating }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
